export enum TipoNotificacao {
	PEDIDOS = <any>'notif:pedidos',
	FINANCEIRO = <any>'notif:financeiro'
}
